document.addEventListener("DOMContentLoaded", function() {
    const faqItems = document.querySelectorAll(".faqs--item");
    let isAnimating = false;
    if (faqItems) {
        faqItems.forEach(item => {
            const question = item.querySelector(".faqs--question");
            const answer = item.querySelector(".faqs--answer");

            // Set base styles
            answer.style.overflow = "hidden";
            answer.style.maxHeight = "0";
            answer.style.transition = "max-height 0.3s ease";

            question.addEventListener("click", function() {
                if (isAnimating) return; // Block clicks during animation
                isAnimating = true;

                const isOpen = item.classList.contains("active");

                // Close all
                faqItems.forEach(i => {
                    i.classList.remove("active");
                    const a = i.querySelector(".faqs--answer");
                    a.style.maxHeight = "0";
                });

                if (!isOpen) {
                    item.classList.add("active");
                    answer.style.maxHeight = answer.scrollHeight + "px";
                }

                // Wait for transition to end
                setTimeout(() => {
                    isAnimating = false;
                }, 300); // Match transition duration (0.3s)
            });
        });
    }
});